import { ArrowTopRightOnSquareIcon as ExternalLinkIcon } from '@heroicons/react/24/outline';

const ServiceAdditionalLinks = ({ additionalLinks }) => (
  <div className="additional-link-container">
    {additionalLinks?.map((additionalLink) => (
      <div key={additionalLink.link} className="additional-link">
        <a className="plain-button" href={additionalLink.link} target="_blank">
          <ExternalLinkIcon className="plain-button-icon" />
          {additionalLink.name}
        </a>
        <div>{additionalLink.description}</div>
      </div>
    ))}
  </div>
);

export default ServiceAdditionalLinks;
